import { render, staticRenderFns } from "./OzlukTanimla.vue?vue&type=template&id=69e75292&scoped=true&"
import script from "./OzlukTanimla.vue?vue&type=script&lang=js&"
export * from "./OzlukTanimla.vue?vue&type=script&lang=js&"
import style0 from "./OzlukTanimla.vue?vue&type=style&index=0&id=69e75292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e75292",
  null
  
)

export default component.exports